import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';


@Injectable()
export class SharedInventoryServices {

    constructor(private http: HttpClient) 
    {
        
    }

    getAllProductsForCases() {
        return this.http.get<any>(environment.inventoryURl + 'Product/ProductsForCases')
        .toPromise()
        .then(res => res);
    }

}